import React from 'react';

const Toast = ({ message, type = 'error', onClose, isVisible }) => {
    if (!isVisible) return null;

    const getToastStyles = () => {
        const baseStyles = "max-w-sm w-full bg-white dark:bg-slate-800 shadow-lg rounded-lg border-l-4 p-4 transform transition-all duration-300 ease-in-out";

        switch (type) {
            case 'success':
                return `${baseStyles} border-green-500 bg-green-50 dark:bg-green-900/20`;
            case 'warning':
                return `${baseStyles} border-yellow-500 bg-yellow-50 dark:bg-yellow-900/20`;
            case 'info':
                return `${baseStyles} border-blue-500 bg-blue-50 dark:bg-blue-900/20`;
            default: // error
                return `${baseStyles} border-red-500 bg-red-50 dark:bg-red-900/20`;
        }
    };

    const getIconStyles = () => {
        const baseStyles = "w-5 h-5 mr-3 flex-shrink-0";

        switch (type) {
            case 'success':
                return `${baseStyles} text-green-500`;
            case 'warning':
                return `${baseStyles} text-yellow-500`;
            case 'info':
                return `${baseStyles} text-blue-500`;
            default: // error
                return `${baseStyles} text-red-500`;
        }
    };

    const getIcon = () => {
        switch (type) {
            case 'success':
                return (
                    <svg className={getIconStyles()} fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                );
            case 'warning':
                return (
                    <svg className={getIconStyles()} fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                );
            case 'info':
                return (
                    <svg className={getIconStyles()} fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                );
            default: // error
                return (
                    <svg className={getIconStyles()} fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>
                );
        }
    };

    return (
        <div className={getToastStyles()}>
            <div className="flex items-start">
                {getIcon()}
                <div className="flex-1">
                    <p className="text-sm font-medium text-slate-900 dark:text-slate-100">
                        {message}
                    </p>
                </div>
                <button
                    onClick={onClose}
                    className="ml-4 flex-shrink-0 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors"
                >
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default Toast;
